import { Company } from "../../setups/types/setupTypes";

export enum InvoiceStatus {
  unpaid = "unpaid",
  partial = "partial",
  paid = "paid",
  cancelled = "cancelled",
}

/** Lightweight employee projection used by the invoicing screens. */
export type InvoiceEmployee = {
  _id: string;
  givenName?: string;
  surName?: string;
  passportNumber?: string;
  statusDates?: { departed?: Date };
  additionalData?: { appliedCountry?: string };
  agentSettlement?: {
    owedAmount?: number;
    reportedAmount?: number;
    invoiceId?: string;
  };
  partner?: Company;
};

export type InvoiceLineItem = {
  employee?: InvoiceEmployee;
  owedAmount: number;
};

export type InvoicePayment = {
  amount: number;
  paymentDate: Date;
  remark?: string;
};

export type Invoice = {
  _id?: string;
  invoiceNumber?: string;
  agent?: Company;
  issueDate?: Date;
  lineItems?: InvoiceLineItem[];
  payments?: InvoicePayment[];
  status?: InvoiceStatus;
  remark?: string;
  totalOwed?: number;
  amountPaid?: number;
  balance?: number;
};

export type InvoicesWithCount = {
  totalCount: number;
  invoices: Invoice[];
};

export type InvoiceArgs = {
  agentId?: string;
  status?: InvoiceStatus;
  skip?: number;
  take?: number;
  refreshList?: string;
};

export type CreateInvoiceArgs = {
  agentId: string;
  issueDate?: Date;
  remark?: string;
  lineItems: { employeeId: string; owedAmount?: number }[];
};

export type RecordPaymentArgs = {
  invoiceId: string;
  amount: number;
  paymentDate?: Date;
  remark?: string;
};

export type GovReportRate = {
  _id?: string;
  country: string;
  amount: number;
};

export type GovReportCountryTotal = {
  country: string;
  count: number;
  total: number;
};

export type GovernmentReport = {
  employees: InvoiceEmployee[];
  totalCount: number;
  totalReported: number;
  countryTotals: GovReportCountryTotal[];
};

export type GovernmentReportArgs = {
  startDate: Date;
  endDate: Date;
};

export type InvoiceState = {
  invoicesWithCount: InvoicesWithCount;
  selectedInvoice: Invoice | null;
  uninvoicedEmployees: InvoiceEmployee[];
  govReportRates: GovReportRate[];
  governmentReport: GovernmentReport | null;
  loading: "idle" | "pending";
  success: any;
  error: any;
};
